module.exports = __webpack_public_path__ + "static/media/Team 9 Logo - Srika Shah.a7b84108.png";